import { create, post as _post, get as _get } from '@byted/ecom-mobile-lib/lib/request/core';
import { API_ORIGIN } from 'config/host';
import Cookies from 'js-cookie';
import axios, { AxiosRequestConfig } from 'axios';
import { postList } from 'config/needProcessPost';
import qs from 'qs';
import bridge from '@byted/ecom-mobile-lib/lib/bridge';
import env from './env';
// EcomDev标识使用开发环境配置。&短路，对production无影响；
export const isDev =
    process.env.NODE_ENV === 'development' && window.navigator.userAgent.indexOf('EcomDev') !== -1;

create({
    timeout: 10000,
    baseURL: API_ORIGIN,
    withCredentials: true,
    postList: postList,
    needDeviceId: true
});

export const resolve = (res: { data: any }, msg = '请求失败') => {
    if (res.data && res.data.st === 0) {
        return res.data.data;
    }
    if (res.data && res.data.code === 0) {
        return res.data.data;
    }
    if (res.data && res.data.status_code === 0) {
        return res.data;
    }
    return Promise.reject(res.data && (res.data.msg || res.data.data) ? res.data : { msg });
    // throw new Error((res.data && res.data.msg) || msg);
};
const defaultConfig = {
    withCredentials: true
};
bridge
    .call('appInfo')
    .then(
        (info: any) => (info && info.device_id ? (info.device_id as number) : 0),
        () => 0
    )
    .then((device_id: number) => {
        commentParams.device_id = device_id;
    });

let commentParams: any = {
    b_type_new: env.bType,
    device_id: 0
};

// 是否是站外
if (!env.isInToutiaoProduct) {
    commentParams.is_outside = 1;
}

const devGet = (url: string, config?: AxiosRequestConfig) =>
    axios.get(url, {
        ...defaultConfig,
        ...getRequestConfig(url, config),
        params: { ...(config && config.params), ...commentParams }
    });

const devPost = (url: string, data: any, config?: AxiosRequestConfig) =>
    axios.post(url, qs.stringify({ ...data, ...commentParams }), {
        ...defaultConfig,
        ...getRequestConfig(url, config)
    });

const getRequestConfig = (url: string, config?: AxiosRequestConfig | undefined) => {
    let requestConfig: AxiosRequestConfig = { ...config };
    // 站外登录解决方案，在 header 塞上 token 鉴权
    if (!env.isInToutiaoProduct && /^https:\/\/ec\.snssdk\.com/.test(url)) {
        const xdToken = Cookies.get('X-Xiaodian-Token');
        let headers = (config && config.headers) || {};
        requestConfig = { ...config, headers };
        if (xdToken) {
            Object.assign(requestConfig.headers, { 'X-Xiaodian-Token': xdToken });
        }
    }
    return requestConfig;
};
const getWrapper = (url: string, config?: AxiosRequestConfig | undefined) =>
    _get(url, getRequestConfig(url, config));
const postWrapper = (url: string, data: any, config?: AxiosRequestConfig | undefined) =>
    _post(url, data, getRequestConfig(url, config));

export const get = isDev ? devGet : getWrapper;
export const post = postWrapper;
